import React from 'react'
import { RotatingLines } from 'react-loader-spinner';
import { getBodyType } from '../../../../../common/services/common.service';

export default function ModalQuotesDetailsComponent({ handleBookLater,
    selectedVehicleItem, quoteDetails, isLoading, enablePlaceOrder, handlePayment, paymentSettings, paymentSelectedInput, handlePaymentInput }: any) {

    const pickupLocation = quoteDetails?.result?.Records[0]?.message?.order?.fulfillments[0]?.start?.location?.address
    const dropLocation = quoteDetails?.result?.Records[0]?.message?.order?.fulfillments[0]?.end?.location?.address
    const items = [
        {
            name: 'Cash',
            description: 'Cash on delivery',
            value: 10,
            checked: '',
            imageUrl: require('../../../../../assets/img/cash.png'),
            show: paymentSettings?.result?.items?.LogisticsmConfigurations?.CargoPaymentMethod?.IsCODOrder,

        },
        {
            name: 'Online',
            description: 'Payment gateway',
            value: 20,
            checked: 'checked',
            imageUrl: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#4a4a4a" fill="none">
                <path d="M16 14C16 14.8284 16.6716 15.5 17.5 15.5C18.3284 15.5 19 14.8284 19 14C19 13.1716 18.3284 12.5 17.5 12.5C16.6716 12.5 16 13.1716 16 14Z" stroke="currentColor" stroke-width="1.5" />
                <path d="M10 7H16C18.8284 7 20.2426 7 21.1213 7.87868C22 8.75736 22 10.1716 22 13V15C22 17.8284 22 19.2426 21.1213 20.1213C20.2426 21 18.8284 21 16 21H10C6.22876 21 4.34315 21 3.17157 19.8284C2 18.6569 2 16.7712 2 13V11C2 7.22876 2 5.34315 3.17157 4.17157C4.34315 3 6.22876 3 10 3H14C14.93 3 15.395 3 15.7765 3.10222C16.8117 3.37962 17.6204 4.18827 17.8978 5.22354C18 5.60504 18 6.07003 18 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
            </svg>,
            show: paymentSettings?.result?.items?.LogisticsmConfigurations?.CargoPaymentMethod?.IsOnlineOrder,
        },
        {
            name: 'Wallet',
            description: 'Wallet',
            value: 40,
            checked: '',
            imageUrl: require('../../../../../assets/img/wallet.png'),

        },
    ];

    return (


        <div className="w-full p-4 bg-white ">
            <h1 className="text-xl font-semibold mb-4 text-center">Confirm Order</h1>

            {/* Order Details */}
            <div>
                <h2 className="px-4  text-lg font-semibold mb-4">Order Details</h2>
                <div className="grid grid-cols-3 gap-4 px-4">
                    <div>
                        <label className="text-base font-medium text-gray-800">Vehicle Type</label>
                        <p className="text-sm font-medium text-gray-600">{getBodyType(selectedVehicleItem?.VehicleBodyTypeId)}</p>
                    </div>
                    <div>
                        <label className="text-base font-medium text-gray-800">Total Distance</label>
                        <p className="text-sm font-medium text-gray-600">{quoteDetails?.result?.Records[0]?.message?.order?.quote?.TotalDistance} km</p>
                    </div>
                    <div>
                        <label className="text-base font-medium text-gray-800">Amount Quoted</label>
                        <p className="text-sm font-medium text-gray-600">₹ {quoteDetails?.result?.Records[0]?.message?.order?.quote?.price?.value}</p>
                    </div>

                </div>
                <div className="border-b border-gray-300 py-2" />
                <div className="grid grid-cols-1 gap-4 pt-2 px-4">

                    <div>
                        <label className="text-base font-medium text-gray-800">Pickup Address</label>
                        <p className="text-sm font-medium text-gray-600">
                            {pickupLocation?.building},  {pickupLocation?.locality},  {pickupLocation?.city},  {pickupLocation?.state}, {pickupLocation?.country} - {pickupLocation?.area_code}.
                        </p>
                    </div>
                    <div>
                        <label className="text-base font-medium text-gray-800">Drop Address</label>
                        <p className="text-sm font-medium text-gray-600">
                            {dropLocation?.building},  {dropLocation?.locality},  {dropLocation?.city},  {dropLocation?.state}, {dropLocation?.country} - {dropLocation?.area_code}.
                        </p>
                    </div>
                </div>
                <div className="border-b border-gray-300 py-2" />
            </div>

            <div className="p-4">
                {/* Payment Details */}
                <h2 className="text-lg font-semibold mb-4">Payment Details</h2>
                <p className="text-base font-medium text-gray-800">Payment Method</p>
                <div className="grid grid-cols-4 gap-4 pt-2">
                    {items?.map((item, index) => (
                        item.show && (
                            <div key={index} className="flex flex-row w-full items-center">
                                <div>
                                    <input
                                        name={item?.name}
                                        type="radio"
                                        placeholder=""
                                        checked={paymentSelectedInput == String(item?.name)}
                                        className={`mx-3  rounded bg-opacity-0 cursor-pointer transform scale-150`}
                                        onChange={(event: any) => {
                                            handlePaymentInput(event, item)
                                            //   handleFormItemChange({
                                            //     value: item?.name,
                                            //     idx: index,
                                            //     field: 'paymentType' // Changed field name to 'paymentType' for consistency
                                            //   })
                                        }}
                                        value={item?.name}
                                    /> </div>

                                <div className='text-sm font-medium text-gray-600'>
                                    {item?.name}
                                </div>

                            </div>
                        )
                    ))}
                </div>

                {/* Action Buttons */}
                <div className="flex justify-end space-x-4 mt-6">
                    <button disabled={isLoading} onClick={handleBookLater} className={`${isLoading ? 'bg-gray-400 rounded-md cursor-not-allowed' : "bg-primary  rounded-md hover:bg-slate-500"} text-light px-4 py-2 `}>
                        Book Later
                    </button>
                    <button
                        onClick={handlePayment}
                        className={`px-6 py-2 text-white rounded-md flex items-center justify-center transition-all relative ${paymentSelectedInput === 'Cash' ? 'w-40' : 'w-52'}
                                 ${isLoading ? 'bg-gray-400 cursor-not-allowed ' : enablePlaceOrder ? 'bg-primary hover:bg-slate-500 ' : 'bg-slate-500 cursor-not-allowed'}`}
                        disabled={!enablePlaceOrder || isLoading}
                    >
                        {paymentSelectedInput === 'Cash' ? 'Place Order' : 'Make a Payment'}
                        {isLoading && (
                            <span className="absolute right-4">
                                <RotatingLines
                                    visible={true}
                                    width={'20'}
                                    strokeColor="#fff"
                                    strokeWidth="6"
                                    animationDuration="0.75"
                                    ariaLabel="rotating-lines-loading"
                                />
                            </span>
                        )}
                    </button>
                </div>
            </div>
        </div>



    )
}